"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultContext = exports.useResult = void 0;
const React = require("react");
const react_1 = require("react");
const resultContext = React.createContext(undefined);
/**
 * Return global {@link Result}, installed via ResultContext.
 *
 * Result is used to set/clear operation results.
 *
 * Result is auto-cleared on history change.
 */
function useResult() {
    const result = (0, react_1.useContext)(resultContext);
    return result;
}
exports.useResult = useResult;
/** Install {@link Result}, used to track action results */
function ResultContext(props) {
    const [resultState, setResultState] = (0, react_1.useState)({
        result: undefined,
        setResult: (result) => setResultState({
            result,
            setResult: resultState.setResult,
        }),
    });
    (0, react_1.useEffect)(() => {
        props.addHistoryChangeListener &&
            props.addHistoryChangeListener(() => {
                resultState.setResult(undefined);
            });
    }, []);
    return React.createElement(resultContext.Provider, { value: resultState }, props.children);
}
exports.ResultContext = ResultContext;
